<!-- Actions for Internal/ MIS Promo Approval/List page -->
<template>
	<div>
		<div v-if="this.user_role !== 'guest'" class="text-center mt-1">
			<vx-tooltip :text="'Edit'" position="bottom" class="inline-flex mr-5 cursor-pointer">
				<feather-icon icon="EditIcon" :svgClasses="`h-4 w-4`" @click="editRow()"/>
			</vx-tooltip>
		</div>	
	</div>	
</template>

<script>	
	export default {
		name: 'CellRendererEditActions',	 
		data() {
			return {  				 
			}
		},
		computed: {
			user_role(){
      	return JSON.parse(localStorage.getItem("userDetails")).role;
			} 
		},
		methods: {
			editRow(){
				var rowData = this.params.rowData;
				var triggerEvent = this.params.triggerEvent;
				
				this.$root.$emit(triggerEvent, rowData);
			}
		}
	}
</script>
<style lang="scss">
    .disabled{
		pointer-events: none;
        opacity: 0.4;
	}
</style>